export * from './has-permission-to-module.directive';